import React from "react";
var __jsx = React.createElement;
import BreadCrumb from "@componentsShared/BreadCrumb";
import getSearchPageCrumbsLinks from "@/pages/search/searchHooks/getSearchPageCrumbsLinks";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useLocation, useParams } from "react-router-dom";
import { isAutosScreen, isCarCountriesScreen, isYearsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
var UnbxdBreadCrumb = function UnbxdBreadCrumb(_ref) {
  var _metaData$seoData;
  var unbxdState = _ref.unbxdState,
    unbxdCore = _ref.unbxdCore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useParams = useParams(),
    make = _useParams.make,
    model = _useParams.model,
    year = _useParams.year;
  var location = useLocation();
  var _useSearchResultsData = useSearchResultsData(),
    selectedOptions = _useSearchResultsData.selectedOptions,
    metaData = _useSearchResultsData.metaData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "mt-2 mb-2",
    links: getSearchPageCrumbsLinks({
      selectedOptions: selectedOptions,
      isYearsPage: isYearsScreen(location),
      isAuto: isAutosScreen(location),
      isCarCountriesPage: isCarCountriesScreen(location),
      make: make,
      model: model,
      year: year,
      location: location,
      t: t,
      createUrl: createUrl,
      seoH1: metaData === null || metaData === void 0 ? void 0 : (_metaData$seoData = metaData.seoData) === null || _metaData$seoData === void 0 ? void 0 : _metaData$seoData.h1
    })
  }));
};
export default UnbxdBreadCrumb;